/**
 * TanStack Query hooks for `multi-language-partner-portal`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	multiLanguagePartnerPortalQueryKeys,
	type CreateMultiLanguagePartnerPortalBody,
	type ListMultiLanguagePartnerPortalResponse,
	type MultiLanguagePartnerPortalRow,
} from "./api";

export function useMultiLanguagePartnerPortalList(): UseQueryResult<ListMultiLanguagePartnerPortalResponse, Error> {
	return useQuery({
		queryKey: multiLanguagePartnerPortalQueryKeys.list(),
		queryFn: list,
	});
}

export function useMultiLanguagePartnerPortalCreate(): UseMutationResult<MultiLanguagePartnerPortalRow, Error, CreateMultiLanguagePartnerPortalBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: multiLanguagePartnerPortalQueryKeys.all });
		},
	});
}

export function useMultiLanguagePartnerPortalDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: multiLanguagePartnerPortalQueryKeys.all });
		},
	});
}
